module.exports = "/_next/static/images/Close-icon-2445c068f2f896add9efbce255652bec.svg";